import { Dictionary } from 'underscore';
import { Messages } from '../../codegen/Localize';
import { DataType } from '../types/DetailEnums';

export const friendlyDataType: () => Dictionary<string> = () => {
  return {
    'STRING': Messages.dataRoleDefinitionSubspace_About_DataType_STRING(),
    'INT': Messages.dataRoleDefinitionSubspace_About_DataType_INT(),
    'FLOAT': Messages.dataRoleDefinitionSubspace_About_DataType_FLOAT(),
    'BOOL': Messages.dataRoleDefinitionSubspace_About_DataType_BOOL(),
    'DATE': Messages.dataRoleDefinitionSubspace_About_DataType_DATE(),
  };
};

export const getFriendlyDataType = (dataType: DataType): string => friendlyDataType()[dataType];
